import { DoctorApiService } from './doctor-api.service';
import { HttpService } from './http.service';
import { TimetableApiService } from './timetable-api.service';
import { PatientApiService } from './patient-api.service';
import { ScheduleApiService } from './schedule-api.service';
import { OrganizationApiService } from './organization-api.service';
import { CommonApiService } from './common-api.service';
import { AuthApiService } from './auth.service';
import { OAuthApiService } from './oauth.service';
import { UploadImageApiService } from './upload-image-api.service';
import { UserApiService } from './user-api.service';
import { ResponseErrorsInterceptor } from './interceptors/response-errors.interceptor';
import { ReceptionApiService } from './reception-api';
import { CrudApiService } from './crud-api.service';
import { ChatApiService } from './chat.service';
import { UploadDocsApiService } from './upload-docs-api.service';
import { UploadSitesApiService } from './upload-sites-api.service';

import { employeeAdapter, doctorAdapter } from './adapters';
import { OpenVidu } from 'openvidu-browser';

const djangoApiUrl = `${process.env.VUE_APP_API_URL || ''}/schedule/api/v1`;
const laravelApiUrl = `${process.env.VUE_APP_API_URL || ''}/api`;
const refbookApiUrl = `${process.env.VUE_APP_API_URL || ''}/refbook/api`;
const oauthApiUrl = `${process.env.VUE_APP_API_URL || ''}/oauth`;
const receptionApiUrl = `${process.env.VUE_APP_API_URL || ''}/reception/api`;


export const http = new HttpService(djangoApiUrl);
http.setResponseInterceptor(
  ResponseErrorsInterceptor.resolve,
  ResponseErrorsInterceptor.reject
);

export const laravelHttp = new HttpService(laravelApiUrl);
export const oauthHttp = new HttpService(oauthApiUrl);
export const refBookHttp = new HttpService(refbookApiUrl);
export const receptionHttp = new HttpService(receptionApiUrl);


export const specialtyApi = new CrudApiService(http, '/specialty/');
export const departmentApi = new CrudApiService(http, '/department/');
export const employeeApi = new CrudApiService(
  http,
  '/employee/',
  employeeAdapter
);
export const doctorApi = new DoctorApiService(http, '/doctor/', doctorAdapter);

export const patientApi = new PatientApiService(http, employeeApi);
export const timetableApi = new TimetableApiService(http, patientApi);
export const scheduleApi = new ScheduleApiService(http);
export const organizationApi = new OrganizationApiService(http);
export const commonApi = new CommonApiService(http);
//export const adminApi = new AdminApiService(http);
//export const receptionApi = new ReceptionApiService(http2);
export const adminApi = new CrudApiService(http, '/admin/organization/');
export const favFormsApi = new CrudApiService(laravelHttp, '/favourite_form/');


export const uploadImageApi = new UploadImageApiService(laravelHttp);
export const uploadDocsApi = new UploadDocsApiService(laravelHttp);
export const uploadSitesApi = new UploadSitesApiService(laravelHttp);
export const authApi = new AuthApiService(laravelHttp);
export const userApi = new UserApiService(laravelHttp);
export const dictionaryMkb10Api = new CrudApiService(refBookHttp, '/mkb10/');
export const dictionaryGrlsApi = new CrudApiService(refBookHttp, '/grls/');
export const dictionaryFiasApi = new CrudApiService(refBookHttp, '/fias/');
export const dictionaryFomsApi = new CrudApiService(refBookHttp, '/foms/');
export const dictionaryLgotiApi = new CrudApiService(refBookHttp, '/lgoti/');



export const chatApi = new ChatApiService(laravelHttp);
export const receptionApi = new ReceptionApiService(receptionHttp);


export const oauthApi = new OAuthApiService(oauthHttp);
export const openVidu = new OpenVidu();
openVidu.enableProdMode();